import { User } from '../../../../types/user';
import AccountOptions from './AccountOptions';
import ResetMFA from './ResetMFA';
import ChangePassword from './ChangePassword';
import PersonalInformation from './PersonalInformation';

type UserProfileProps = {
    user: User;
};

function UserProfile({ user }: UserProfileProps): JSX.Element {
    const nonSSO = user.auth0Id.startsWith('auth0|');
    return (
        <div className="grid gap-y-4">
            <PersonalInformation user={user} />
            <ChangePassword />
            {nonSSO && <ResetMFA user={user} />}
            {/* <AccountOptions /> */}
        </div>
    );
}

export default UserProfile;
